import React from "react";
import "./Footer.css";
import logo from "../assets/images/qodes_logo.png";
// Import social media icons - you'll need to add these images to your assets/images folder
import facebookIcon from "../assets/images/facebook-icon.png";
import instagramIcon from "../assets/images/instagram-icon.png";
import linkedinIcon from "../assets/images/linkedin-icon.png";
import podcastIcon from "../assets/images/podcast-icon.png";

const Footer = () => {
  const handleLogoClick = () => {
    window.location.href = '/';
  };

  const socialLinks = [
    {
      icon: facebookIcon,
      alt: "Facebook",
      url: "https://facebook.com/qodes", // Replace with actual Facebook URL
      label: "Visit our Facebook page",
      size: 1
    },
    {
      icon: instagramIcon,
      alt: "Instagram",
      url: "https://instagram.com/qodes_gbg", // Replace with actual Instagram URL
      label: "Visit our Instagram page",
      size: 1.8
    },
    {
      icon: linkedinIcon,
      alt: "LinkedIn",
      url: "https://linkedin.com/company/qodes-ab", // Replace with actual LinkedIn URL
      label: "Visit our LinkedIn page",
      size: 1.7
    },
    {
      icon: podcastIcon,
      alt: "Podcast",
      url: "https://pod.link/1684693153", // Replace with actual podcast URL
      label: "Listen to our podcast",
      size: 1.3
    }
  ];

  const handleSocialClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="footer">
      <span className="copyright">© 2014–2025 Qodes AB</span>
      <img
        src={logo}
        alt="Qodes logo"
        className="footer-logo"
        onClick={handleLogoClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleLogoClick();
          }
        }}
        tabIndex="0"
        role="button"
        aria-label="Go to homepage"
      />
      <div className="social-placeholders" role="list" aria-label="Social media links">
        {socialLinks.map((social, i) => (
          <button
            key={i}
            className="social-button"
            onClick={() => handleSocialClick(social.url)}
            aria-label={social.label}
            type="button"
          >
            <img
              src={social.icon}
              alt={social.alt}
              className="social-icon"
              style={{ width: `${social.size}em` }}
            />
          </button>
        ))}
      </div>
    </footer>
  );
};

export default Footer;